import { observer } from 'mobx-react-lite'
import { AuthorizationDocumentCommon } from 'pages/settings/ui/AuthorizationDocumentCommon'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'

export const AuthorizationDocument = observer(() => {
  const {
    textEnableLandlineStore: { authorizationDocumentStore },
    nextClickHandler,
  } = useNewInboxStepsContext()
  return (
    <>
      <AuthorizationDocumentCommon authorizationDocumentStore={authorizationDocumentStore} />
      <NextButton text='Next' onClick={nextClickHandler} />
    </>
  )
})
